// extracted by mini-css-extract-plugin
export default {"ldsRoller":"loader_ldsRoller__aVjf2","lds-roller":"loader_lds-roller__2vke3","logo":"loader_logo__sDNCd","logoAnimation":"loader_logoAnimation__UelWk"};